// extracted by mini-css-extract-plugin
module.exports = {"block":"CheckoutFormIndirizzo_block__drbKc","indirizzoBlock2":"CheckoutFormIndirizzo_indirizzoBlock2__mTDxk","rotation":"CheckoutFormIndirizzo_rotation__pr7_8"};